import colorScale from '@root/lib/colorScale'

const DATASET_INDEX = 0

function roundRect ({ ctx, x, y, width, height, borderRadius }) {
  const topLeftRadius = borderRadius[0]
  const topRightRadius = borderRadius[1]
  const bottomRightRadius = borderRadius[2]
  const bottomLeftRadius = borderRadius[3]

  const xEnd = x + width
  const yEnd = y + height

  ctx.beginPath()
  ctx.moveTo(x + topLeftRadius, y)
  ctx.lineTo(xEnd - topRightRadius, y)
  ctx.quadraticCurveTo(xEnd, y, xEnd, y + topRightRadius)
  ctx.lineTo(xEnd, y + height - bottomRightRadius)
  ctx.quadraticCurveTo(xEnd, yEnd, xEnd - bottomRightRadius, yEnd)
  ctx.lineTo(x + bottomLeftRadius, yEnd)
  ctx.quadraticCurveTo(x, yEnd, x, yEnd - bottomLeftRadius)
  ctx.lineTo(x, y + topLeftRadius)
  ctx.quadraticCurveTo(x, y, x + topLeftRadius, y)
  ctx.fill()
}

function triangle ({ ctx, x, y, width, height }) {
  ctx.beginPath()
  ctx.moveTo(x, y)
  ctx.lineTo(x, y + height)
  ctx.lineTo(x + width, y + height)
  ctx.lineTo(x, y)
  ctx.fill()
}

function drawTooltip ({ chart, itemIndex }) {
  const ctx = chart.tooltipCanvas.getContext('2d')
  ctx.clearRect(0, 0, chart.tooltipCanvas.width, chart.tooltipCanvas.height)

  const data = chart.getDatasetMeta(DATASET_INDEX).data
  let { x, y } = data[itemIndex]._model

  const chartWidth = chart.chartArea.right
  const chartTop = chart.chartArea.top

  if (y < chartTop) y = chartTop

  const itemData = chart.data.datasets[DATASET_INDEX].data[itemIndex]

  const label = `Heute ${itemData.x}:00 Uhr`
  const value = itemData.y
  ctx.font = `normal 11px Interstate`
  const labelTextWidth = ctx.measureText(label).width

  const boxWidth = labelTextWidth + 20
  const boxHeight = 55
  let triangleWidth = 17
  let triangleHeight = 17
  let boxX, boxY, borderRadius

  const boxXPosition = x > chartWidth - boxWidth ? 'left' : 'right'
  const boxYPosition = y - boxHeight - triangleHeight < chartTop ? 'bottom' : 'top'
  const boxPosition = `${boxYPosition}-${boxXPosition}`

  switch (boxPosition) {
    case 'top-left':
      boxX = x - boxWidth
      boxY = y - boxHeight - triangleWidth + 1
      triangleWidth = -triangleWidth
      triangleHeight = -triangleHeight
      borderRadius = [5, 5, 0, 5]
      break
    case 'bottom-left':
      boxX = x - boxWidth
      boxY = y + triangleHeight - 1
      triangleWidth = -triangleWidth
      borderRadius = [5, 0, 5, 5]
      break
    case 'bottom-right':
      boxX = x
      boxY = y + triangleHeight - 1
      borderRadius = [0, 5, 5, 5]
      break
    default: // top-right
      boxX = x
      boxY = y - boxHeight - triangleHeight + 1
      triangleWidth = 17
      triangleHeight = -17
      borderRadius = [5, 5, 5, 0]
  }

  ctx.fillStyle = colorScale(value)
  roundRect({ ctx, x: boxX, y: boxY, width: boxWidth, height: boxHeight, borderRadius: borderRadius })
  triangle({ ctx, x, y, width: triangleWidth, height: triangleHeight })

  ctx.fillStyle = 'white'
  ctx.textBaseline = 'alphabetic'
  ctx.textAlign = 'left'
  ctx.fillText(label, boxX + 10, boxY + 18)
  ctx.font = `bold 20px Interstate`
  const valueTextWidth = ctx.measureText(value).width
  ctx.fillText(value, boxX + 10, boxY + 42)
  ctx.font = `bold 14px Interstate`
  ctx.fillText('μg/m³', boxX + 10 + 2 + valueTextWidth, boxY + 42)
}

export default {
  afterInit: function (chart) {
    const tooltipCanvas = document.createElement('canvas')
    const canvasParent = chart.canvas.parentNode

    tooltipCanvas.style.position = 'absolute'
    tooltipCanvas.style.pointerEvents = 'none'

    canvasParent.appendChild(tooltipCanvas)
    chart.tooltipCanvas = tooltipCanvas
  },

  afterDraw: function (chart, easing) {
    // if (easing < 0.8) return
    let data = chart.getDatasetMeta(DATASET_INDEX).data
    const lastItemIndex = data.length - 1

    chart.tooltipCanvas.width = chart.canvas.width
    chart.tooltipCanvas.height = chart.canvas.height
    drawTooltip({ chart: chart, itemIndex: lastItemIndex })
  },

  afterEvent: function (chart, event) {
    let data = chart.getDatasetMeta(DATASET_INDEX).data
    let distances = data.map(data => Math.abs(data._model.x - event.x))
    var indexOfMinDistance = distances.reduce((minIndex, distance, index, arr) =>
      distance < arr[minIndex] ? index : minIndex, 0)

    drawTooltip({ chart: chart, itemIndex: indexOfMinDistance })
  }
}
